module.exports = __webpack_public_path__ + "img/product-preview-16.71425a7.png";